import { rnd } from "../components/MainPage";

export const getRandomLimit = ({ limits, sideValue }) => {
  let orderLimit = 0;
  const limitIncrements = [0.01, 0.02, 0.03, 0.04, 0.05];
  const sellLimitOptions = [limits.lower, null];
  const buyLimitOptions = [limits.upper, null];
  const increment = limitIncrements[rnd(0, 4)];

  if (sideValue === "BUY") {
    const selectedLimit = buyLimitOptions[rnd(0, 1)];
    orderLimit = selectedLimit ? selectedLimit + increment : selectedLimit;
  } else {
    const selectedLimit = sellLimitOptions[rnd(0, 1)];
    orderLimit = selectedLimit ? selectedLimit - increment : selectedLimit;
  }
  return orderLimit;
};
